import React, { ReactNode } from 'react';
import FormFieldTitleBar from './FormFieldTitleBar';

const FormGroup = ({ children, title }: { children: ReactNode; title?: string }): JSX.Element => {
    return (
        <div className="component-form-group">
            {title ? <FormFieldTitleBar title={title} /> : null}
            <div className="form-content">{children}</div>
        </div>
    );
};

export default FormGroup;
